
<div class="k">
<div class="container-fluid">
    <div class="col-lg-12 col-md-12 col-sm-12  full-length">
      <div id="myCarousel" class="carousel slide" data-ride="carousel">
        <!-- Indicators -->
        <ol class="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
          <li data-target="#myCarousel" data-slide-to="1"></li>
          <li data-target="#myCarousel" data-slide-to="2"></li>
          <li data-target="#myCarousel" data-slide-to="3"></li>
        </ol>


        <div class="carousel-inner">

          <div class="item active">
            <img src="../../assets/About.jpg">
            <div class="carousel-caption">
              <div class="top-left">
              <h1 class="h1"><span class="h2">Your</span> Wellness<span class="h2"><br/>is in your</span> Hands</h1>
              <p>Take a tour to
              <a routerLink="/wellness">
                <button type="button" class="bb">Know More <i class="bi bi-chevron-double-right"></i></button>
              </a></p>
            </div>
          </div>
          </div>

          <div class="item">
            <img src="assets/Banner2.jpg">
            <div class="carousel-caption">
              <div class="top-left">
              <h1 class="h1"><span class="h2">Building</span> Immunity<br/><span class="h2">Levels</span> Naturally</h1>
              <!-- <p>Check out our 
              <a href="https://aayurway.myshopify.com/collections/capsules" target="_blank">
                <button type="button" class="bb">Natural Healers <i class="bi bi-chevron-double-right"></i></button>
              </a></p> -->
            </div>
          </div>
          </div>

          <div class="item">
            <img src="assets/Banner3.jpg">
            <div class="carousel-caption">
              <div class="top-left">
              <h1 class="h1"><span class="h2">Health</span> <br/>Practitioners<br/><span class="h2">at</span> Your <span class="h2">Service</span></h1>
              <p>
              <a routerLink="/talktodoctor">
                <button type="button" class="bb">Book an Appointment <i class="bi bi-chevron-double-right"></i></button>
              </a> right away </p>
            </div>
          </div>
          </div>

          <div class="item">
            <img src="assets/Banner4.jpg">
            <div class="carousel-caption">
              <div class="top-left">
              <h1 class="h1"> Helping <span class="h2"><br/>Others in their </span><br/>Wellness Journey</h1>
              <p>Come, 
              <a routerLink="/providercorner">
                <button type="button" class="bb">Join the Team <i class="bi bi-chevron-double-right"></i></button>
              </a></p>
            </div>
          </div>
          </div>

        </div>

        <!-- Left and right controls -->
        <a class="carousel-control" href="#myCarousel" data-slide="prev">
          <span class="glyphicon glyphicon-chevron-left"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control bar" href="#myCarousel" data-slide="next">
          <span class="glyphicon glyphicon-chevron-right"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
<!-- </div> -->
<div class="container-fluid back">
  <div class="col-lg-12 col-md-12">
  <h2>{{brandData?.brandName}} Showing The Way For Optimal Health, Immunity And Care</h2>
  <p>As a pseudoscientific theory and practice of alternative medicine, Ayurveda has predominantly been part of the Indian subcontinent for 5000 years. The healthy lifestyle system that Ayurveda promotes is one of the best holistic cures in modern-day treatment. Being torchbearers of Ayurveda, at {{brandData?.brandName}}, we show you the ‘way’ to achieve overall wellness in life.</p>
  
</div>
<div class="col-lg-12 col-md-12 why">
  <h2>Why Ayurveda</h2>
  <!-- <p>Translated literally as the ‘science’ or Ved of ‘life’ or Ayur, Ayurveda is a traditional alternative medicine modality that has credible success in potentially curing and preventing illnesses by balancing all aspects of life. However, unlike western medicine, Ayurveda does not restrict itself to just curing the symptoms but focuses on healing the patient of the root cause of illness.</p> -->
  <p>Translated literally as the ‘science’ or Ved of ‘life’ , Ayurveda is a traditional alternative medicine modality that has credible success in potentially curing and preventing illnesses by balancing all aspects of life. However, unlike western medicine, Ayurveda does not restrict itself to just curing the symptoms but focuses on healing the patient of the root cause of illness.</p>
<a routerLink="/team">
 <button type="button" class="bb">Know More <i class="bi bi-chevron-double-right"></i></button>
</a>
</div>
<!-- <div class="col-lg-4 col-md-4">
 <img src="assets/intro-img.png" class="intro-img">
  
</div> -->

</div>
<div class="container wellness">
  <div class="col-lg-12 col-md-12 col-sm-12 box">
    <div class="">
      <h2>Focusing on Optimal Health</h2>
      <p>At {{brandData?.brandName}}, we focus on assisting you in enriching all areas of your life by creating greater awareness and mindful guidance. We understand that the road to good health is an endless journey. Hence our recommendations are focused on guiding you to healthy lifestyle choices without burning a hole in your pocket.</p>
      <p>Our focus is on ensuring that the world around us is surrounded by people with optimum health. We strive each day to get you there. Just join the wellness brigade; we are your Way to wHealth!</p>
      
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 box1">
    <div class="">
      <img src="assets/wellness.jpg" class="img-responsive">
      <a routerLink="/wellness"><button type="button" class="bb2">Let's Begin <i class="bi bi-chevron-double-right"></i></button></a>
    </div>
  </div>
</div>
<div class="container products">
    <div class="col-lg-12 col-md-12 col-sm-12 ">
      <h2>Products That’ll Get You There</h2>
      <p>Staying healthy is all about ensuring that the body gets the necessary share of nutrients that helps build immunity. {{brandData?.brandName}}’s products enjoy the sanctity of Ayurveda and have the ability to restore balance in the mind-body system. Incorporating the 3000-year-old concept of natural healthcare, unique combinations of herbs can be consumed as capsules.</p>
      <p>{{brandData?.brandName}}’s products focus on what’s the need of the hour – immunity! The human race has been subjected to various diseases and infections for centuries. We have been able to fight it off and survive due to our evolving immunity system. Our products help give the right boost that’s that offers optimum immunity. You can choose our natural immunity boosters and enjoy the health-balancing remedies they offer.</p>
      <!-- <a href="https://aayurway.myshopify.com/collections/capsules" target="_blank"><button type="button" class="bb">Check Our Traditional Healers <i class="bi bi-chevron-double-right"></i></button></a> -->
    </div>

    
    <!-- <div class="col-lg-4 col-md-4 col-sm-4 triangle">
    <img src="../../assets/resource/under_constructiong.gif" > 
    </div> -->
</div>
<!-- <div class="container">
  <div class="col-lg-6 col-md-6 col-sm-12 hr">
    <h1 class="about-us"><span>AYURLS </span>Showing <br>The Way For Optimal Health, Immunity And Care</h1>
   <button type="button" class="btn bb"><span class="btn-arrow">Know More</span></button>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-12">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <h1 class="about-us"><span>Products</span><br> That'll Get <br><span class="about-us">You </span>There</h1>
      <button type="button" class="btn bb"><span class="btn-arrow">Check Our Traditional Healers</span></button>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
     <img src="assets/shopping.png">
   
  </div>
  </div>
</div> -->

<div class="container medical">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <h2  class="medical" >Medical professionals for Consultations</h2>
    <p>At {{brandData?.brandName}}, we understand that mental health, overall wellbeing, and resilience form an intrinsic part of our lives. Our professionals are focused on how best to help you look after yourselves and those around you. Spread across Disease Management, Lifestyle Management, Therapy, and Care Services, our experts have got your back.</p>
        
  </div>
</div>
<div class="container">
  <div class="col-lg-12 col-md-12 doctor">
      <div class="row">
        <div class="col-lg-offset-3 col-lg-3 col-md-offset-3 col-md-3">
          <img src="assets/doctor-1.jpg">
          <figcaption class="m-text">Establishing a personal connection</figcaption>
        </div>
        <div class="col-lg-3 col-md-3">
            <img src="assets/doctor-2.jpg">
            <figcaption class="m-text">Taking the time to understand your situation or condition</figcaption>
        </div>
    </div>
    <div class="row">
      <div class="col-lg-offset-3 col-lg-3 col-md-offset-3 col-md-3">
        <img src="assets/doctor-3.jpg">
        <figcaption class="m-text">Offering the best-in-line remedies or recommendations</figcaption>
      </div>
      <div class="col-lg-3 col-md-3">
        <img src="assets/doctor-4.jpg">
        <figcaption class="m-text">Following up on health and lifestyle changes</figcaption>
      </div>
    </div>
  </div>

    <div class="col-lg-12 col-md-12 med">
      <h3>Our holistic approch to any condition or disease aids in understanding Your health needs.<br>Would you like to
        consult our Medical experts?</h3>
        <a routerLink="/talktodoctor"><button type="button" class="bb2">Book An Appointment <i class="bi bi-chevron-double-right"></i></button></a>

    </div>
  
  
  
  </div>
  <div class="container provider">
    <div class="col-lg-12 col-md-12 col-sm-12 box">
      <div class="">
        <h2>Changing Lives Together</h2>
        <p>Are you a medical practitioner who is keen on making a difference in society? Would you love to be part of a holistic yet compatible team of medical experts? Just connect with us, and we can together help people achieve optimum health. The more lives we touch, the more we can contribute.<br><br></p>
       
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 box1">
      <div class="">
        <img src="assets/provider.jpg" class="img-responsive" >
        <a routerLink="/providercorner">
          <button type="button" class="bb2 lives">Join The Team <i class="bi bi-chevron-double-right"></i></button>
        </a> 
      </div>
    </div>
  </div>
</div>
  